var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrap"},[_c('i',{staticClass:"material-icons",class:( _obj = {}, _obj[_vm.iconColor] = true, _obj )},[_vm._v(_vm._s(_vm.icon))]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }